/**
 * 地図クリック（青ピン）用のタグ同期システム
 * PropertySelectionGridと地図クリックポップアップ間でタグデータを同期するためのユーティリティ
 */

import { createPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const MAP_CLICK_TAG_UPDATE_EVENT = "updateMapClickTags";

const { dispatch, addListener } = createPropertyGridPopupSyncSystem<string[]>(
  MAP_CLICK_TAG_UPDATE_EVENT
);

/**
 * 地図クリックのタグ更新イベントを発火する
 * ポップアップが開かれた際に最新のタグでフォームを更新するために使用
 * @param tags 更新するタグの配列
 */
export const dispatchMapClickTagUpdate = (tags: string[]): void => {
  dispatch(tags);
};

/**
 * 地図クリックのタグ更新イベントリスナーを追加する
 * @param callback タグが更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addMapClickTagUpdateListener = (
  callback: (tags: string[]) => void
): (() => void) => {
  return addListener(callback);
};
